import {Component, OnInit} from '@angular/core';
import {Information} from '../../../../model/information';
import {InformationsService} from '../../../../services/informations.service';
import {RouterLink} from "@angular/router";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {CommonModule} from "@angular/common";
import {BadgeComponent} from "../../../common/badge/badge.component";
import {DashBlockComponent} from "../dash-block.component";

@Component({
    selector: 'app-dash-block-infos',
    templateUrl: './dash-block-infos.component.html',
    imports: [
        CommonModule,
        RouterLink,
        FaIconComponent,
        BadgeComponent,
        DashBlockComponent
    ],
    styleUrls: ['./dash-block-infos.component.css']
})
export class DashBlockInfosComponent implements OnInit {
  infos: {
    showIcon: boolean;
    info: Information;
  }[];

  maxDirectInfos = 3;

  constructor(private informationsService: InformationsService) {
  }

  ngOnInit(): void {
    this.informationsService.getObjects().subscribe(data => {
      let currentDirectInfos = 0;
      let firstDirectInfo = true;
      this.infos = data.filter(info => info.type === 'DIRECT' || info.type === 'PINNED').filter(info => {
        const directType = info.type === 'DIRECT';
        if (directType) {
          currentDirectInfos++;
          return currentDirectInfos <= this.maxDirectInfos;
        }
        return true;
      }).map(info => {
        let showIcon = true;
        if (info.type === 'DIRECT') {
          if (firstDirectInfo) {
            firstDirectInfo = false;
          } else {
            showIcon = false;
          }
        }
        return {showIcon, info};
      });
    });
  }

}
